import axios from 'axios';
import { HubConnectionBuilder } from '@microsoft/signalr';
import productDomain from '../utils/productDomain';

const SOCKET = new HubConnectionBuilder()
  .withUrl(`${process.env.REACT_APP_API_URL}ws/session`, {
    withCredentials: false,
  })
  .withAutomaticReconnect()
  .build();

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    product: productDomain,
  },
});

export default API;
export { SOCKET };
